import React, { useState, useEffect, useRef } from "react";
import "../DashBoard/sliding.css";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { sidebarReducer, contentReducer } from "../../Redux/store";
import SlidingPane from "react-sliding-pane";

import { Paper, TextField, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

function List3DContents() {
  const dispatch = useDispatch();

  // Selectors
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);
  const token = useSelector((state) => state.AccessTocken.accessTocken);
  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);
  const View_Permission = useSelector((state) => state.AccessTocken.View_Permission);


  // State variables
  const [contentData, setContentData] = useState([]);
  const [contentCount, setContentCount] = useState(null);
  const [viewCards, setViewCards] = useState(true);
  const [showBy, setShowBy] = useState("All content");

  // Pagination states
  const [index1_pagenation, setIndex1_pagenation] = useState(1);
  const [index2_pagenation, setIndex2_pagenation] = useState(2);
  const [index3_pagenation, setIndex3_pagenation] = useState(3);
  const [index4_pagenation, setIndex4_pagenation] = useState(4);
  const [noOfPages, setNoOfPages] = useState(null);
  const [pageSelected, setPageSelected] = useState(1);

  // API headers
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Pagination styles
  const onPage = {
    cursor: "pointer",
    backgroundColor: "RGB(200, 200, 200)",
    scale: "1.2",
    height: "25px",
  };
  const notOnPage = { cursor: "pointer", scale: "1" };

  // Fetch initial data
  // const responseData = async () => {
  //   try {
  //     dispatch(sidebarReducer.apiLoad(true));

  //     const contentResponse = await axios.get(
  //       `threedcontent/list/?page=1&limit=${listLimit}`,
  //       options
  //     );

  //     if (contentResponse.status === 200) {
  //       const contentRows = contentResponse.data.data.rows || [];
  //       console.log("Content Data:", contentRows);

  //       // Calculate pages
  //       const totalCount = contentResponse.data.data.count || 0;
  //       const pages = totalCount === 0 ? 1 : Math.ceil(totalCount / listLimit);
  //       setContentData(contentRows);
  //       setContentCount(totalCount);
  //       setNoOfPages(pages);
  //     }

  //     dispatch(sidebarReducer.apiLoad(false));
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     dispatch(sidebarReducer.apiLoad(false));
  //     dispatch(sidebarReducer.stringUpdate("AppDown"));
  //   }
  // };
  const responseData = async () => {
    try {
      dispatch(sidebarReducer.apiLoad(true));
  
      const contentResponse = await axios.get(
        `threedcontent/list/?page=1&limit=${listLimit}`,
        options
      );
  
      if (contentResponse.status === 200 && contentResponse.data?.data) {
        const contentRows = contentResponse.data.data.rows || [];
        
        if (contentRows.length === 0) {
          // Optionally show a toast or log a message
          console.warn("Received empty content rows");
        }
  
        setContentData(contentRows);
        setContentCount(contentResponse.data.data.count || 0);
        setNoOfPages(Math.max(1, Math.ceil((contentResponse.data.data.count || 0) / listLimit)));
      } else {
        console.error("Invalid response structure:", contentResponse);
        // Optionally set an error state or show a toast
      }
  
      dispatch(sidebarReducer.apiLoad(false));
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(sidebarReducer.apiLoad(false));
      dispatch(sidebarReducer.stringUpdate("AppDown"));
      
      // Optionally implement a retry mechanism
      // setTimeout(responseData, 3000);
    }
  };

  const pagenationAPi = async (pageNo) => {
    try {
      dispatch(sidebarReducer.apiLoad(true));
      setPageSelected(pageNo);

      const response = await axios.get(
        `threedcontent/list/?page=${pageNo}&limit=${listLimit}`,
        options
      );

      if (response.status === 200) {
        const contentRows = response.data.data.rows || [];
        setContentData(contentRows);
      }

      dispatch(sidebarReducer.apiLoad(false));
    } catch (error) {
      console.error("Pagination error:", error);
      dispatch(sidebarReducer.apiLoad(false));
      dispatch(sidebarReducer.stringUpdate("AppDown"));
    }
  };

  // Pagination navigation functions
  const leftArrow = () => {
    if (pageSelected > 1) {
      setPageSelected(prev => prev - 1);
      pagenationAPi(pageSelected - 1);

      // Adjust pagination indices
      if (index1_pagenation > 1) {
        setIndex1_pagenation(prev => prev - 1);
        setIndex2_pagenation(prev => prev - 1);
        setIndex3_pagenation(prev => prev - 1);
        setIndex4_pagenation(prev => prev - 1);
      }
    }
  };

  const rightArrow = () => {
    if (pageSelected < noOfPages) {
      setPageSelected(prev => prev + 1);
      pagenationAPi(pageSelected + 1);

      // Adjust pagination indices
      if (index4_pagenation < noOfPages) {
        setIndex1_pagenation(prev => prev + 1);
        setIndex2_pagenation(prev => prev + 1);
        setIndex3_pagenation(prev => prev + 1);
        setIndex4_pagenation(prev => prev + 1);
      }
    }
  };


  // useEffect(() => {
  //   if (View_Permission === 1) {
  //     responseData();
  //   }
  // }, []);
  useEffect(() => {
  
      responseData();
 
  }, []);
 


  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 p-0 Image" style={{ minHeight: "100vh" }}>
          {/* Header */}
          <div className="row g-0 p-0">
            <div className="col">
              <div className="g-0 m-0 border-top" style={{ backgroundColor: "#f2f3f5" }}>
                <div className="row p-0 border-bottom">
                  <div className="col-3" style={{ height: "50px" }}>
                    <div className="d-flex flex-row">
                      <div className="p-2 mt-1">
                        <h5>
                          <strong>3D_Content</strong>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Content Display */}
          <div className="row g-0 p-0">
            <div className="col">
              <div className="container-fluid g-0">
                {viewCards && showBy === "All content" && (
                  <div>
                    {apiLoad ? (
                      <div
                        style={{
                          height: "80vh",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div className="spinnerApi"></div>
                      </div>
                    ) : (
                      <div className="ContentCardMain d-flex flex-wrap border-top">
                        {!contentData || contentData.length === 0 ? (
                          <h6
                            style={{
                              marginLeft: "500px",
                              marginTop: "10px",
                            }}
                          >
                            No Data Found
                          </h6>
                        ) : (
                          contentData.map((item, index) => (
                            <div className="ms-5 mt-5" key={index}
                            // title="Click on the card to view 3D model"
                            // onClick={() => {
                            //   const productID = item.te_productid; 
                            //   const url = `http://localhost:1234?token=${token}&productID=${productID}`;
                            //   window.open(url, "_blank"); 
                            // }}
                            >
                             <div
                                className={`card shadow-sm mb-3 contentThreeD ${
                                  item.te_contenttype === "video"
                                    ? "Video"
                                    : item.te_contenttype === "image"
                                    ? "Image"
                                    : item.te_contenttype === "audio"
                                    ? "Audio"
                                    : item.te_contenttype === "file"
                                    ? "File"
                                    : item.te_contenttype === "text"
                                    ? "Text"
                                    : null
                                }`}
                                style={{
                                  height: "250px",
                                  borderRadius: "10px",
                                  maxWidth: "245px",
                                  minWidth: "245px",
                                  border: "2px solid #009900 !important",
                                }}
                              >
                                <div className="top"></div>
                                <div
                                  className="logoContent"
                                  style={{ borderRadius: "25px" }}
                                >
                                  <img
                                    style={{
                                      height: "50px",
                                      width: "50px",
                                    }}
                                    src={require("../../images/3dlogo.png")}
                                    alt="C_LOGO"
                                  />
                                </div>
                                <span className="ToolTipP">
                                <p
                                  className="pt-4 mt-1 ps-2 m-0"
                                  style={{ fontSize: "1rem" }}
                                >
                                  {item.te_filename}
                                </p>
                                <span className="ToolTipTextP">
                                File Name
                                      </span>
                                </span>
                                <span className="ToolTipP">
                                <p       
                                  className="ps-2 m-0"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {item.te_buname} / {item.te_divisionname}
                                </p>
                                <span className="ToolTipTextP">
                                Business Unit/ Division
                                      </span>
                                </span>
                                <span className="ToolTipP">
                                <p className="ps-2 mb-0">
                                  {item.te_productname}
                                </p>
                                <span className="ToolTipTextP">
                                Product Name
                                      </span>
                                </span>
                                {item.te_3dcontentstatus === "1" && (
                                  <div
                                    className="rounded-start text-center text-white"
                                    style={{
                                      position: "absolute",
                                      width: "80px",
                                      backgroundColor: "rgb(58,201,53)",
                                      top: "8px",
                                      right: "0px",
                                      height: "20px",
                                    }}
                                  >
                                    <span
                                      className=""
                                      style={{
                                        fontSize: "14px",
                                        position: "relative",
                                        top: "-2px",
                                      }}
                                    >
                                      Active
                                    </span>
                                  </div>
                                )}
                                {item.te_3dcontentstatus === "0" && (
                                  <div
                                    className="rounded-start text-center text-white"
                                    style={{
                                      position: "absolute",
                                      width: "80px",
                                      backgroundColor: "rgb(201,53,53)",
                                      top: "8px",
                                      right: "0px",
                                      height: "20px",
                                    }}
                                  >
                                    <span
                                      className=""
                                      style={{
                                        fontSize: "14px",
                                        position: "relative",
                                        top: "-2px",
                                      }}
                                    >
                                      InActive
                                    </span>
                                  </div>
                                )}
                                <hr
                                  className="m-0"
                                  style={{
                                    marginTop: "2px",
                                    marginBottom: "2px",
                                  }}
                                />
                                <div className="card-body pt-2 ps-1">
                                  <p
                                    className="g-0"
                                    style={{
                                      maxWidth: "90%",
                                      minWidth: "89%",
                                      maxHeight: "10px",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {item.te_contentdescription}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          </div>
          {/* Pagination Footer */}
          {!apiLoad && showBy !== "Product" && showBy !== "Applications" && (
            <div className="container">
              <div className="row main-footer">
                <div className="col-3 mt-2" style={{ whiteSpace: "nowrap" }}>
                  Total Records: {contentCount}
                </div>
                <div className="col-4 mt-2">
                  <div className="d-flex justify-content-center ">
                    <div>
                      <i
                        className="bi bi-chevron-left"
                        style={{ cursor: "pointer" }}
                        onClick={leftArrow}
                      ></i>
                    </div>
                    {[index1_pagenation, index2_pagenation, index3_pagenation, index4_pagenation]
                      .filter(index => index <= noOfPages)
                      .map(index => (
                        <div
                          key={index}
                          className="px-2 mx-1 rounded"
                          style={index === pageSelected ? onPage : notOnPage}
                          onClick={() => pagenationAPi(index)}
                        >
                          {index}
                        </div>
                      ))}
                    <div>
                      <i
                        className="bi bi-chevron-right"
                        style={{ cursor: "pointer" }}
                        onClick={rightArrow}
                      ></i>
                    </div>
                  </div>
                </div>
                <div className="col-3 mt-2 ">
                  <div className="d-flex justify-content-end me-3">
                    <span>
                      <strong>Page {pageSelected} </strong> of{" "}
                      <strong>{noOfPages}</strong>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
       
      </div>
    </div>
  );
}

export default List3DContents;